/**
 * P3-32: Transcend 按钮。
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import { useTranscendButtonModel } from "./useReligionModel";
import { t } from "../../bridge/i18n";

interface TranscendButtonProps {
  handler: () => void;
}

export function TranscendButton({ handler }: TranscendButtonProps) {
  const { snap, modelRef, controller, getTooltip } = useTranscendButtonModel(
    t("religion.transcendBtn.label"),
    t("religion.transcendBtn.desc"),
    handler,
  );

  const onClick = useCallback(
    (event: MouseEvent) => {
      if (controller && modelRef.current) {
        controller.buyItem?.(modelRef.current, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
    />
  );
}
